// Keep Horizon's announcement controls, but disable automatic rotation for reduced motion.
const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
customElements.whenDefined('announcement-bar-component').then(() => {
  const sync = () => {
    document.querySelectorAll('announcement-bar-component').forEach((element) => {
      const bar = /** @type {import('./announcement-bar.js').AnnouncementBar} */ (element);
      bar.suspend();
      if (motion.matches) bar.pause();
      else bar.play();
    });
  };
  sync();
  motion.addEventListener('change', sync);
});

// A deep link to a product-specific chart must also disclose its contents.
document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('.dh-fit a');
  if (!(link instanceof HTMLAnchorElement)) return;
  const details = document.getElementById(link.hash.slice(1));
  if (details instanceof HTMLDetailsElement) details.open = true;
});
